import { render, staticRenderFns } from "./SinglePurchasePayments.vue?vue&type=template&id=924617e6&"
import script from "./SinglePurchasePayments.vue?vue&type=script&lang=js&"
export * from "./SinglePurchasePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePurchasePayments.vue"
export default component.exports